import { Link, useLocation } from 'react-router';
import { useTranslation } from 'react-i18next';
import { findNavItem, screenFor } from '../app/screens';
import { navItemLabel } from '../app/navAr';
import { useUi } from '../app/ui';
import { ScanBox } from './ScanBox';
import { NotificationBell } from './NotificationBell';
import { LangSwitch } from './LangSwitch';
import { ThemeSwitch } from './ThemeSwitch';

// White sticky top bar: hamburger (drawer trigger below 1000px), crumbs "Group / Title", scan box, bell with red count, language button.
// Below 640px the bar wraps to two rows (overrides.css): menu · crumbs · bell · language, then the scan box.
export function TopBar() {
  const { t } = useTranslation();
  const lang = useUi((s) => s.lang);
  const toggleSidebar = useUi((s) => s.toggleSidebar);
  const sidebarOpen = useUi((s) => s.sidebarOpen);
  const setPaletteOpen = useUi((s) => s.setPaletteOpen);
  const { pathname } = useLocation();

  const meta = screenFor(pathname);
  const hit = meta ? findNavItem(`/${meta.nav}`) : undefined;
  const group = hit ? (lang === 'ar' ? hit.group.labelAr : hit.group.label) : t('crumbs.root');
  const title = meta ? t(meta.titleKey) : t('crumbs.root');
  const itemLabel = hit ? navItemLabel(hit.item.route, hit.item.label, lang) : undefined;

  return (
    <header id="topbar">
      <button id="menuBtn" type="button" className="btn sm" aria-label={t('topbar.menu')} aria-expanded={sidebarOpen} onClick={toggleSidebar}>
        ☰
      </button>
      <div className="crumbs" id="crumbs">
        {group} / <b>{title}</b>
        {itemLabel && itemLabel !== title && <span className="muted"> ({itemLabel})</span>}
      </div>
      <ScanBox />
      <button id="paletteBtn" type="button" className="btn sm palette-hint" onClick={() => { setPaletteOpen(true); }} title={t('palette.label')}>
        <span aria-hidden="true">⌕</span> <kbd>Ctrl</kbd><kbd>K</kbd>
      </button>
      {/* the way to the guides from anywhere — the sidebar entry can be a drawer away on a narrow screen */}
      <Link id="helpBtn" className="btn sm" to="/help" title={t('help.title')} aria-label={t('help.title')}>
        <span aria-hidden="true">?</span>
      </Link>
      <NotificationBell />
      <ThemeSwitch />
      <LangSwitch />
    </header>
  );
}
